import { peachButtonStyle } from '../lib/theme';

interface Props {
  onConfirm: () => void;
}

export default function AteOutButton({ onConfirm }: Props) {
  return (
    <button onClick={onConfirm} style={peachButtonStyle}>
      Ate out / delivery, skip logging
    </button>
  );
}
